import React, { useEffect }  from 'react';
import { Modal, TitleBar } from "@shopify/app-bridge-react";
import { setInitialPath } from '../../slice';
import { store } from '../../store';
import { useSelector } from 'react-redux';
const SourceRequestModal = ({
    handleDifferentModalOpen
})=> {
  const initialPath = useSelector((state) => state.languageReducer.initialPath);
    // Shopify 属性
    const modalHideAction = ()=>{
        handleDifferentModalOpen(false,initialPath)
    }
    useEffect(() => {
        // 如果没有记录初始路径，存储来源路径
        if (!initialPath) {
          store.dispatch(setInitialPath("/admin/dashboard"));
        }
      }, [initialPath]);
   
    return (
        <Modal id="Plan_Page_Modal" src={'/admin/subscribe'} variant={"max"} onHide={modalHideAction}>
        <TitleBar title={"DSM - Subscription"} />
    </Modal>
    );
}

export default SourceRequestModal;
